// extracted by mini-css-extract-plugin
export var adjacentSlide = "_os-9";
export var arrowButtonContainer = "_os-5";
export var arrowButtonIcon = "_os-6";
export var carouselArrowButton = "_os-2";
export var carouselElementContainer = "_os-1";
export var currentSlide = "_os-8";
export var left = "_os-3";
export var otherSlide = "_os-a";
export var productCarouselContainer = "_os-0";
export var right = "_os-4";
export var sliderOverflow = "_os-7";